// @flow

import { Flex } from "@chakra-ui/react";
import React from "react";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import type { ChecklistBuilderField } from "src/types";

import SortableItem from "./SortableItem";

type Props = {
  items: ChecklistBuilderField[],
  itemIds: string[],
  updateField: Function,
  addFields: Function,
  removeField: Function,
  openSettings: Function,
};

const SortableList = ({
  items,
  itemIds,
  updateField,
  addFields,
  removeField,
  openSettings,
}: Props) => {
  return (
    <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
      <Flex
        flexDirection="column"
        sx={{
          alignItems: "start",
          gap: "1rem",
          mt: 2,
          mb: 8,
        }}
      >
        {items.map((value, index) => (
          <SortableItem
            key={itemIds[index]}
            id={itemIds[index]}
            position={index}
            addFields={addFields}
            openSettings={openSettings}
            updateField={updateField}
            removeField={removeField}
          />
        ))}
      </Flex>
    </SortableContext>
  );
};

export default SortableList;
